import { FileMetadata as _FileMetadata } from './fileMetadata';
import { ImportTableDefinition as _ImportTableDefinition } from './importTableDefinition';
import { ImportTableDefinitionRevision as _ImportTableDefinitionRevision } from './importTableDefinitionRevision';
import { ImportTask as _ImportTask } from './importTask';
import { SourceSystem as _SourceSystem } from './sourceSystem';
import * as _Util from './util';

export namespace ImportContext {
  export import FileMetadata = _FileMetadata;
  export import ImportTableDefinition = _ImportTableDefinition;
  export import ImportTableDefinitionRevision = _ImportTableDefinitionRevision;
  export import ImportTask = _ImportTask;
  export import SourceSystem = _SourceSystem;

  export namespace Util {
    export const applyTransformRules = _Util.applyTransformRules;
    export const applyTransformRulesToValue = _Util.applyTransformRulesToValue;
    export const buildCompositeKey = _Util.buildCompositeKey;
    export const pickColumnsForDestination = _Util.pickColumnsForDestination;
    export const mergeCustomerMetadata = _Util.mergeCustomerMetadata;
  }
}
